// extracted by mini-css-extract-plugin
export default {"turnstileHost":"Turnstile_turnstileHost__hHzhb"};